import { useMutation } from '@tanstack/react-query'
import { crefazService } from '../services/crefazService'
import { MakeProposalPayload } from '../services/crefazService/makeProposal'
import { toast } from '@/view/components/ui/use-toast'

export const useCrefazMutations = () => {
  const checkAvailabilityMutation = useMutation({
    mutationFn: (cep: string) => crefazService.getAvailability(cep),
    onError: (error: any) => {
      toast({
        title: 'Erro ao verificar disponibilidade',
        description: error?.message || 'Tente novamente mais tarde.',
        variant: 'destructive',
      })
    },
  })

  const makeProposalMutation = useMutation({
    mutationFn: (payload: MakeProposalPayload) =>
      crefazService.makeProposal(payload),
    onError: (error: any) => {
      toast({
        title: 'Erro ao criar proposta',
        description: error?.message || 'Tente novamente mais tarde.',
        variant: 'destructive',
      })
    },
  })

  return {
    checkAvailabilityMutation,
    makeProposalMutation,
  }
}
